/**
 * @author evdokimov
 */
import BaseFormMediator from './BaseFormMediator'
import BudgetedVsActualEditFormConfigController from './edit_config_controller/BudgetedVsActualEditFormConfigController'
import EstimateVsActualHTMLPreviewGenerator from './preview/html/eva/EstimateVsActualHTMLPreviewGenerator'
import EstimateVsActualCSVPreviewGenerator from './preview/csv/eva/EstimateVsActualCSVPreviewGenerator'
import {ReportGroupingLevel} from './constants'
import ATReportParamsStringBuilder from './reportParamsStringBuilder/ATReportParamsStringBuilder'

export default function EstimatedVsActualFormMediator() {}

EstimatedVsActualFormMediator.prototype = new BaseFormMediator();

EstimatedVsActualFormMediator.prototype.init = function ( config ) {
    BaseFormMediator.prototype.init.call(this, config);

    ATReportsStore.setCPList(config.cpList);

    return this;
};

EstimatedVsActualFormMediator.prototype.initEditConfigController = function ( config ) {
    return new BudgetedVsActualEditFormConfigController().init(
            {
                panelId: "mainContainer",
                reportParameters: config.reportParameters,
                cpList: config.cpList,
                customersWithMaIds: config.customersWithMaIds,
                projectsWithMaIds: config.projectsWithMaIds,
                changeCallback: () => this.changeParametersCallback(),
                reportAuthorizationInfo: config.reportAuthorizationInfo,
            } )
};

EstimatedVsActualFormMediator.prototype.createDateRangeSelector = function( reportParameters ) {
    var dateRangeSelectorConfig = {
        dateRangeSelection: reportParameters.dateSelection,
        menuStates: new DateRangeMenuItemsUtil().createDefaultSingleDateMenuItems(),
        shortDateFormat: true
    };

    return new SingleDateSelectorController().init(dateRangeSelectorConfig);
};

EstimatedVsActualFormMediator.prototype.initParamsStringBuilder = function(config) {
    return new ATReportParamsStringBuilder({
        data: {
            cpList: config.cpList,
            manageableUserIds: ATReportsStore.getManageableUserIds(),
            projectsWithMaIds: ATReportsStore.getProjectsWithMaIds(),
        },
        reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo(),
    })
}

EstimatedVsActualFormMediator.prototype.fillDateSelection = function ( reportParametersObject )
{
    reportParametersObject.dateSelection = this.dateRangeSelector.getSelectedRange();
};

EstimatedVsActualFormMediator.prototype.initCsvGenerator = function(){
    return new EstimateVsActualCSVPreviewGenerator().init();
};

EstimatedVsActualFormMediator.prototype.initHtmlGenerator = function(){
    return new EstimateVsActualHTMLPreviewGenerator().init();
};

EstimatedVsActualFormMediator.prototype.exportToCSV = function()
{
    var reportParams = this.collectReportParameters();

    var successMethod = function(result)
    {
        var info = {};
        var groupingLevels = EVAReport.ConvertUtils.getGroupingLevels(reportParams);
        var groupingLevelsCollapsed = EVAReport.ConvertUtils.getGroupingLevelsCollapsed(groupingLevels);
        for (var i = 0; i < result["groupingLevelsInfoLists"].length; ++i)
        {
            info[groupingLevelsCollapsed[i]] = result["groupingLevelsInfoLists"][i];
        }

        var customersMap = _.extend(arrayToMapById(ATReportsStore.getCPList().customers), arrayToMapById(info[ReportGroupingLevel.CUSTOMER]));
        var projectMap = _.extend(arrayToMapById(ATReportsStore.getCPList().projects), arrayToMapById(info[ReportGroupingLevel.PROJECT]));
        var projectNamesMap = arrayToMapById(info[ReportGroupingLevel.PROJECT_NAME]);
        var tasksMap = arrayToMapById(info[ReportGroupingLevel.TASK]);
        var taskNamesMap = arrayToMapById(info[ReportGroupingLevel.TASK_NAME]);
        var typesOfWorkMap = arrayToMapById(info[ReportGroupingLevel.BILLING_TYPE]);
        var usersMap = arrayToMapById(info[ReportGroupingLevel.USER]);

        return new EVACSVJsonConverter().init(customersMap, projectMap, tasksMap, usersMap, projectNamesMap, taskNamesMap, typesOfWorkMap, null,
                                                       EVAReport.FormatUtils.makeGroupingPresentationFlags(groupingLevels));
    };
    
    var serviceParams = [
        {
            qualifier: reportParams.dateSelection.qualifier,
            date: reportParams.dateSelection.date.toJSON()
        },
        EVAReport.ConvertUtils.getGroupingLevels(reportParams),
        reportParams.customersProjectsSelection,
        reportParams.tasksConfig,
        reportParams.includeNotStarted,
        reportParams.includeNotEstimated
    ];
    
    this._exportToCSV(reportParams, successMethod, "EvAReportService.getReport", serviceParams);
};


// WEBPACK FOOTER //
// ./web/js/reports/EstimatedVsActualFormMediator.js